/* global document */
import React, { useState, useContext, useMemo} from 'react';
import PropTypes from 'prop-types';
import { FaFilePdf } from 'react-icons/fa';
import { FaFloppyDisk } from 'react-icons/fa6';
import { BiZoomIn } from 'react-icons/bi';
import { ToastContext } from './context/ToastContext';
import ModalComponentNoButton from './ModalComponentNoButton';
import { Spinner } from 'react-bootstrap';
import '../styles/ProductPDFViewer.css';

/**
 * Component for showing the pdf card .
 * @component
 */
const ProductPDFViewer = ({ pdf }) => {
    const [showPDFModal, setShowPDFModal] = useState(false);
    const { sendMessage } = useContext(ToastContext);
    const [loading, setLoading] = useState(false);

    const handlePDFDownload = async (url, fileName = 'download.pdf') => {
        try {
            const response = await fetch(url);
            if (response.ok) {
                const blob  = await response.blob();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                throw new Error('Network response was not ok');
            }
       
        } catch (err) {
            sendMessage(err.message, 'danger');
        } 
    };

    const handleShowPDF = () => {
        setShowPDFModal(!showPDFModal);
        setLoading(true);
    };

    const { title, name } = useMemo(() => {
        const localFilename = pdf.Attachment.localFilename?.split('-')?.slice(4).join('-');
        const name = localFilename?.split('.');
        name?.pop();
        const title = name?.join('.');
        return {
            title,
            localFilename,
        };
    }, [pdf.Attachment.localFilename]);
    
    /* Render content */
    return <div 
        className={'d-flex flex-column align-items-center border border-secondary p-1 rounded'} 
        style={{
            width: '14em',
        }}
    >
        <ModalComponentNoButton
            modalTriggerText={title}
            modalTitle={title}
            show={showPDFModal}
            setShow={setShowPDFModal}
            showConfirmButton={false}
            size={'xl'}
            contentClassName={'modal-content-class'}
        >
            <div
                style={{ 
                    position: 'relative',
                    width: '100%',
                    height: '100%', 
                }}>
                {loading && (
                    <div 
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 1000,
                        }}
                    >
                        <Spinner
                            animation={'border'} />
                    </div>
                )}
                <iframe
                    src={pdf.url}
                    width={'100%'}
                    height={'100%'}
                    title={title}
                    onLoad={() => setLoading(false)}
                    style={{display: loading ? 'none' : 'block'}}
                />
            </div>
        </ModalComponentNoButton>

        <div
            style={{
                width:'100%',
                textAlign:'center',
                whiteSpace:'nowrap',
                overflow:'hidden',
            }}>{title}</div>

        <FaFilePdf 
            color={'red'}
            size={55}
            style={{margin:'0.5em'}}
        />

        <div
            className={'d-flex gap-1 mt-1'}>
            <button
                onClick={handleShowPDF}
                className={'py-0 rounded d-flex gap-1 align-items-center'}
                color={'#14639c'}><BiZoomIn /> View</button>
            <button
                onClick={() => handlePDFDownload(pdf.url,name)}
                className={'py-0 rounded d-flex gap-1 align-items-center'}
                color={'#14639c'}><FaFloppyDisk /> Download</button>
        </div>
    </div>;
};

ProductPDFViewer.propTypes = {
    pdf: PropTypes.object,
};

export default ProductPDFViewer;
